module.exports = __webpack_public_path__ + "img/balloon_right.1d4c0006.png";